module.exports = __webpack_public_path__ + "img/screen-4.e4dcc76b.jpg";